import { Stack } from "@mui/material";
import React from "react";
import DetailsTreeContainer from "../../../../shared-components/hoa-view-details-draw-container";
import {
	StringComponentForProcedure,
	ArrayComponentForProcedure,
} from "../../../../shared-components/hoa-view-tabs-item-component";

const processItem = (item: any): React.ReactNode[] =>
	Object.entries(item).flatMap(([key, value]) => {
		if (typeof value === "string") {
			return <StringComponentForProcedure key={key} title={key} value={value} />;
		} else if (Array.isArray(value)) {
			return <ArrayComponentForProcedure key={key} title={key} value={value} />;
		}
		return null;
	});

const ProcedureComponent: React.FC<{ details: any }> = ({ details }) => {

  	const isObjectEmpty = (obj: any) => {
    	return Object.keys(obj).length === 0 && obj.constructor === Object;
  	};

  	const filteredDetails = Object.entries(details).filter(([key, value]: any) => {
    	return !value.every((item: any) => isObjectEmpty(item));
  	});

  	return filteredDetails.map(([key, value]: any, index: number) => {

    const isLastItem = index === filteredDetails.length - 1;

	return (
      <Stack sx={{ position: "relative" }} key={key} borderBottom={!isLastItem ? "1px solid #E8E8E8" : "none"}>
        	<Stack m={3}>
          		<span className="text-3E3E3E-18px">{key}</span>
          		<DetailsTreeContainer key={key} data={value} processItem={processItem} />
        	</Stack>
      </Stack>
    );
  });
};

export default ProcedureComponent;
